<template>
  <article ref="popupContainerRef" class="relative">
    <slot name="trigger" />

    <FloatingMenu v-if="showing" :class="['absolute z-20', contentClass]" arrow-position="none">
      <slot name="content" />
    </FloatingMenu>
  </article>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    contentClass?: string
  }>(),
  {
    contentClass: 'mt-4 min-w-128',
  },
)
const showing = defineModel<boolean>({ default: false })
const popupContainerRef = ref<any | null>(null)

useClickOutside([computed(() => popupContainerRef.value)], ref(false), () => {
  if (showing.value) showing.value = false
})
</script>
